import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";



class HatirlatmaKoduAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "HatirlatmaKoduListe";
    super(baseUrl);
  }


  getHatirlatmaKoduListe( hatirlatmaKodu?: number){
    return this.get("", { params: { hatirlatmaKodu: hatirlatmaKodu } })

  }

}
export default new HatirlatmaKoduAPI();
class HatirlatmaKoduRequest {
  public hatirlatmaKodu?: number;

  constructor( hatirlatmaKodu?: number) {
   
        this.hatirlatmaKodu = hatirlatmaKodu;

  }
}
export { HatirlatmaKoduRequest };